<div class="container-item cp" [ngClass]="{'active': _categoria.Selected}" (click)="toogleActive(_categoria)">
    <label class="cp">{{ _categoria.Categoria }}</label>
</div>